import type { ReactNode } from 'react';
import { memo } from 'react';

import { Box } from '@simplywallst/ui-core';

import { Canvas } from './components/Canvas';

import { Labels } from './components/Labels';
import { DotMarkers } from './components/DotMarkers';

import {
  Segments,
  DividendSegment,
  PastSegment,
  ValueSegment,
  HealthSegment,
  FutureSegment,
} from './components/Segments';

const MemoCanvas = memo(Canvas);

export interface Props {
  points: [number, number, number, number, number];
  styleType?: 'light' | 'dark';
  width?: number;
  children?: ReactNode;
}

type SnowflakeNamespace<Props> = React.FC<Props> & {
  Labels: typeof Labels;
  DotMarkers: typeof DotMarkers;
  Segments: typeof Segments;
  DividendSegment: typeof DividendSegment;
  PastSegment: typeof PastSegment;
  ValueSegment: typeof ValueSegment;
  HealthSegment: typeof HealthSegment;
  FutureSegment: typeof FutureSegment;
};

export const Snowflake: SnowflakeNamespace<Props> = ({
  styleType = 'dark',
  points,
  width,
  children,
}: Props) => {
  return (
    <Box maxWidth={width || '280px'}>
      <Box
        width={width || '100%'}
        position="relative"
        style={{ paddingTop: '100%' }}
      >
        <Box position="absolute" top="0" bottom="0" left="0" right="0">
          <MemoCanvas
            valueScores={points[0]}
            futureScores={points[1]}
            pastScores={points[2]}
            healthScores={points[3]}
            dividendScores={points[4]}
            styleType={styleType}
            width={width}
          />
          <Box position="relative">{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

Snowflake.Labels = Labels;
Snowflake.DotMarkers = DotMarkers;
Snowflake.Segments = Segments;
Snowflake.DividendSegment = DividendSegment;
Snowflake.PastSegment = PastSegment;
Snowflake.ValueSegment = ValueSegment;
Snowflake.HealthSegment = HealthSegment;
Snowflake.FutureSegment = FutureSegment;
